// Finance, DMS (Dealership) and Procurement: switches, permission sets and approval types.
// Mirrors the API's src/common/platform/config.js - keep the two in step.
//
// Menus follow GET platform/access (which modules are on for the vendor, and the
// caller's permission sets); the API checks everything again on every request.

export const MODULES = {
  FIN: { label: "Finance", adminPermission: "FIN_CONTROLLER" },
  DMS: { label: "Dealership", adminPermission: "DMS_ADMIN" },
  PROC: { label: "Procurement", adminPermission: "PROC_ADMIN" },
};

export const FIN_PERMISSIONS = {
  FIN_CONTROLLER: "FIN_CONTROLLER",
  FIN_ACCOUNTANT: "FIN_ACCOUNTANT",
  FIN_AR: "FIN_AR",
  FIN_AP: "FIN_AP",
  FIN_VIEWER: "FIN_VIEWER",
};

export const DMS_PERMISSIONS = {
  DMS_ADMIN: "DMS_ADMIN",
  DMS_SALES_MANAGER: "DMS_SALES_MANAGER",
  DMS_SALES: "DMS_SALES",
  DMS_SERVICE_ADVISOR: "DMS_SERVICE_ADVISOR",
  DMS_TECHNICIAN: "DMS_TECHNICIAN",
  DMS_PARTS: "DMS_PARTS",
  DMS_CASHIER: "DMS_CASHIER",
};

export const PROC_PERMISSIONS = {
  PROC_ADMIN: "PROC_ADMIN",
  PROC_BUYER: "PROC_BUYER",
  PROC_APPROVER: "PROC_APPROVER",
  PROC_VIEWER: "PROC_VIEWER",
};

export const EMPTY_MODULE_ACCESS = {
  modules: {},
  permissions: [],
  scoped_permissions: [],
  is_tenant_admin: false,
  is_employee: false,
  approvals: { pending: 0 },
};

// `access` is the `data` of GET platform/access.
export const isModuleEnabled = (access, module, feature = "CORE") => !!access?.modules?.[module]?.features?.[feature];

export function hasModulePermission(access, module, ...permissions) {
  if (!isModuleEnabled(access, module)) return false;
  if (access.is_tenant_admin) return true;
  return permissions.some((p) => (access.permissions || []).includes(p));
}

export const isModuleAdmin = (access, module) => hasModulePermission(access, module, MODULES[module].adminPermission);

// Anyone holding any permission of the module (or the owner / an admin).
export const hasAnyModulePermission = (access, module, list) => hasModulePermission(access, module, ...Object.values(list));
